import { render, staticRenderFns } from "./ResumeclinicModal.vue?vue&type=template&id=54548fcb"
import script from "./ResumeclinicModal.vue?vue&type=script&lang=js"
export * from "./ResumeclinicModal.vue?vue&type=script&lang=js"
import style0 from "./ResumeclinicModal.vue?vue&type=style&index=0&id=54548fcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports